export default "__VITE_ASSET__GgU2k$0x__"